/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const credit_note = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2 8.5 1 9.654l1 1.154M1 9.654h3.333C5.253 9.654 6 8.793 6 7.73s-.746-1.923-1.667-1.923H3M3.856 3v-.35a1 1 0 0 1 1-1h5.176a1 1 0 0 1 .763.354l2.639 3.119a1 1 0 0 1 .237.646v7.582a1 1 0 0 1-1 1H4.856a1 1 0 0 1-1-1V13"
    />
  </svg>
)
export default credit_note
